import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { getPacienteToken } from '../../services/pacienteConfig';

const PacienteProtectedRoute = () => {
  const token = getPacienteToken();

  if (!token) {
    return <Navigate to="/paciente/login" replace />;
  }

  return <Outlet />;
};

export default PacienteProtectedRoute;
